module.exports = __webpack_public_path__ + "img/down-arrow.53bcd28e.svg";